export default __webpack_public_path__ + "static/media/mercury.d7b738ce.svg";